import { Box, Typography } from "@mui/material";
import React from "react";
import { GadgetPlaform } from "../../Home/components/gadgets/GadgetPlaform";
import styles from "../css/GadgetPlatformInfo.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faApple, faChrome, faWindows } from '@fortawesome/free-brands-svg-icons';

interface GadgetPlatformInfoProps {
    header: string,
    icon : React.ReactNode,
    platform: GadgetPlaform | undefined,
    dataTestId: string
}

interface IconProps {
  platform: GadgetPlaform | undefined,
}

export const Icon = ({ platform }: IconProps) => {
  const getIconClass = (platformType: string) => {
    const convertedValue = GadgetPlaform[platform?.toString() as keyof typeof GadgetPlaform];
    return convertedValue === platformType ? styles.iconDefault: styles.iconOpaque;
  }

  return (
      <>
          <FontAwesomeIcon icon={faWindows} size={"3x"} className={getIconClass(GadgetPlaform.WINDOWS)}/>
          <FontAwesomeIcon icon={faApple} size={"3x"} className={getIconClass(GadgetPlaform.MAC)}/>
          <FontAwesomeIcon icon={faChrome} size={"3x"} className={getIconClass(GadgetPlaform.WEB)}/>
      </>
  );
};

export const GadgetPlatformInfo = ({header, icon, platform, dataTestId}: GadgetPlatformInfoProps) => {
  return (
    <Box>
      <div className={styles.headerContainer}>
        {icon}
        <Typography variant="h4" className={styles.headerText}>{header}</Typography>
      </div>
      <Box className={styles.platformContainer} data-testid={dataTestId}>
        <Icon platform={platform}/>
      </Box>
    </Box>
  );
};